import { createFileRoute } from "@tanstack/react-router";
import { VortexAuthSignUpPage } from "@vortexnyc/vortex-core/auth/react";

import { signUpClassNames } from "../integrations/vortex-auth/class-names";
import { authClient } from "../integrations/vortex-auth/client";
import {
  authRoutePaths,
  useAppAuth,
} from "../integrations/vortex-auth/runtime";

export const Route = createFileRoute("/sign-up")({
  component: SignUpPage,
});

function SignUpPage() {
  const auth = useAppAuth();

  return (
    <VortexAuthSignUpPage
      auth={auth}
      authClient={authClient}
      classNames={signUpClassNames}
      description="Create your account, then continue into portal organization setup."
      // The plan is explicit: do not auto-create an org. Route the new user to
      // /select-organization where they can create or join one.
      forceRedirectUrl="/select-organization"
      signInUrl={authRoutePaths.signInPath}
      title="Create your account"
    />
  );
}
